import React from "react";
import { AiFillStar } from "react-icons/ai";

const Review = ({ index, title, comment, score }) => {
  let stars = [];

  for (let i = 0; i < score; i++) {
    stars.push(<AiFillStar />);
  }

  return (
    <div key={index} className="review-container">
      <p className="review-title">{title}</p>
      <p>{comment}</p>
      {stars.map((star, index) => (
        <span key={index}>{star}</span>
      ))}
    </div>
  );
};

export default Review;
